import styled, { css } from 'styled-components'
import { border, layout, padding, position } from 'styled-system'
import { themeGet } from '@styled-system/theme-get'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

const shouldForwardProp = prop => {
  return ![...DIV_SHOULD_FORWARD_PROP, 'right'].includes(String(prop))
}

export const Container = styled.div
  .attrs({
    py: [5, 5, 5, 5, 5, 5, 7],
    px: [5, 5, 7, 7, 7, 7, 9],
    borderRadius: [10, 10, 10, 10, 10, 10, 20],
  })
  .withConfig({
    shouldForwardProp,
  })`
  display: flex;
  align-items: center;
  position: absolute;
  background-color: ${themeGet('colors.white')};
  box-shadow: 0 20px 40px 0 #2b2b601a;
  z-index: 12;

  > svg {
    width: 20px;
    height: 20px;

    @media screen and (min-width: ${themeGet('breakpoints.2')}) {
      width: 24px;
      height: 24px;
    }

    @media screen and (min-width: ${themeGet('breakpoints.5')}) {
      width: 40px;
      height: 40px;
    }
  }

  ${border}
  ${padding}
  ${position}
`

const plusHolderRightCss = ({ right }) =>
  right &&
  css`
    right: 0;
    left: unset;
    transform: translateY(-50%) translateX(50%);
  `

export const PlusIconHolder = styled.div
  .attrs({
    size: [28, 28, 28, 28, 28, 28, 40],
  })
  .withConfig({
    shouldForwardProp,
  })`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  border-radius: 20px;
  background-color: ${themeGet('colors.deepCove')};
  border: 3px solid ${themeGet('colors.white')};
  top: 0;
  left: 0;
  transform: translateY(-50%) translateX(-50%);

  > svg {
    color: ${themeGet('colors.white')};
  }

  ${layout}

  ${plusHolderRightCss}
`
